import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string | null} State */
const initialState = null;

const selectOne = (_, { payload: questionModelId }) => questionModelId;

export default createReducer(initialState, {
  [types.SELECT_QUESTION_MODEL]: selectOne,
});
